import { HOUR_IN_MILLISECONDS } from 'reservations/base/constants/time';

export const DEFAULT_QUERY_OPTIONS = {
  staleTime: HOUR_IN_MILLISECONDS,
  gcTime: HOUR_IN_MILLISECONDS,
  refetchInterval: HOUR_IN_MILLISECONDS
};
